import { render, staticRenderFns } from "./LegendOptions.vue?vue&type=template&id=18f8caa5&lang=pug&"
import script from "./LegendOptions.vue?vue&type=script&lang=ts&"
export * from "./LegendOptions.vue?vue&type=script&lang=ts&"
import style0 from "./LegendOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports